import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { EcallEquipmentSummaryService } from './ecall-equipment-summary.service';

import { DialogHelper, ExceptionHelper } from './../../../../helper';
import * as $ from 'jquery';

@Component({
  selector: 'app-ecall-equipment-summary',
  templateUrl: './ecall-equipment-summary.component.html'
})
export class EcallEquipmentSummaryComponent implements OnInit {

  id = '';
  equipments: any[];
  dataTable: any;

  constructor(
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private ecallEquipmentSummaryService: EcallEquipmentSummaryService,
    private route: ActivatedRoute,
    private router: Router,
    private chRef: ChangeDetectorRef,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang('en-us');
    this.route.params.subscribe(params => {
      this.id = params['id'];
    });
  }

  ngOnInit() {
    this.getEquipmentDetail();
  }

  getEquipmentDetail() {
    this.ecallEquipmentSummaryService
      .getSummary(this.id)
      .subscribe(
        data => {
          if ($.fn.dataTable.isDataTable('#equipmentDataTables')) { $('#equipmentDataTables').DataTable().destroy(); }
          this.equipments = data.equipmentListModel;
          this.chRef.detectChanges();

          const table: any = $('#equipmentDataTables');
          this.dataTable = table.DataTable();
        },
        error => {
          this.exception.showError(error, 'showDanModalBtn');
        }
      );
  }

  errorClose() {
    this.router.navigate(['/home/e-call']);
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/ecall/ecall-detail/ecall-equipment-summary.component.ts